/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_Court_ViewInputs */

const th_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูหน้าสนาม →`)
};

const en_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open court view →`)
};

const ja_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コートビューを開く →`)
};

const zh_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开球场视图 →`)
};

const es_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir vista de pista →`)
};

const pt_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir visão da quadra →`)
};

const id_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka tampilan lapangan →`)
};

const fr_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir la vue terrain →`)
};

const tl_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan ang tanaw ng court →`)
};

const vi_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở khung nhìn sân →`)
};

const ko_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코트 화면 열기 →`)
};

const de_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feldansicht öffnen →`)
};

const ru_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть вид площадки →`)
};

const tr_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saha görünümünü aç →`)
};

const it_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri la vista campo →`)
};

const pl_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz widok boiska →`)
};

const uk_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрити вигляд майданчика →`)
};

const hi_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोर्ट दृश्य खोलें →`)
};

const ar_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح عرض الملعب ←`)
};

const ms_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka paparan gelanggang →`)
};

const bn_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোর্টের দৃশ্য খুলুন →`)
};

const zh_tw2_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟球場檢視 →`)
};

const zh_hk2_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟球場檢視 →`)
};

const ur_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کورٹ کا منظر کھولیں ←`)
};

const fa_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باز کردن نمای زمین ←`)
};

const sw_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua mwonekano wa kiwanja →`)
};

const nl_open_court_view = /** @type {(inputs: Open_Court_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veldweergave openen →`)
};

/**
* | output |
* | --- |
* | "Open court view →" |
*
* @param {Open_Court_ViewInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const open_court_view = /** @type {((inputs?: Open_Court_ViewInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Court_ViewInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_open_court_view(inputs)
	if (locale === "ja") return ja_open_court_view(inputs)
	if (locale === "zh") return zh_open_court_view(inputs)
	if (locale === "es") return es_open_court_view(inputs)
	if (locale === "pt") return pt_open_court_view(inputs)
	if (locale === "id") return id_open_court_view(inputs)
	if (locale === "fr") return fr_open_court_view(inputs)
	if (locale === "tl") return tl_open_court_view(inputs)
	if (locale === "vi") return vi_open_court_view(inputs)
	if (locale === "ko") return ko_open_court_view(inputs)
	if (locale === "de") return de_open_court_view(inputs)
	if (locale === "ru") return ru_open_court_view(inputs)
	if (locale === "tr") return tr_open_court_view(inputs)
	if (locale === "it") return it_open_court_view(inputs)
	if (locale === "pl") return pl_open_court_view(inputs)
	if (locale === "uk") return uk_open_court_view(inputs)
	if (locale === "hi") return hi_open_court_view(inputs)
	if (locale === "ar") return ar_open_court_view(inputs)
	if (locale === "ms") return ms_open_court_view(inputs)
	if (locale === "bn") return bn_open_court_view(inputs)
	if (locale === "zh-TW") return zh_tw2_open_court_view(inputs)
	if (locale === "zh-HK") return zh_hk2_open_court_view(inputs)
	if (locale === "ur") return ur_open_court_view(inputs)
	if (locale === "fa") return fa_open_court_view(inputs)
	if (locale === "sw") return sw_open_court_view(inputs)
	if (locale === "nl") return nl_open_court_view(inputs)
	return en_open_court_view(inputs)
});